/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRef.vue?vue&type=template&id=6ade29e9&scoped=true"
import script from "./popRef.vue?vue&type=script&lang=js"
export * from "./popRef.vue?vue&type=script&lang=js"
import style0 from "./popRef.vue?vue&type=style&index=0&id=6ade29e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade29e9",
  null
  
)

export default component.exports